export function makeResponsiveTable(element, messagetext) {
    const text = element.dataset.responsiveTable || messagetext || '';
    const svgSpriteUrl = element.dataset.spriteUrl || '/images/icons/icons.sprite.svg';
    const message = document.createElement('div');
    const messageTextContainer = document.createElement('div');
    const iconContainer = document.createElement('div');
    const iconPointer = `<span class="spv-button__icon spv-icon spv-icon--size48"><svg focusable="false"><use xlink:href="${svgSpriteUrl}#icon-arrow-right"></use></svg></span>`;
    message.classList.add('spv-scrollbox__message');
    messageTextContainer.classList.add('spv-scrollbox__message__text');
    iconContainer.classList.add('spv-scrollbox__message__icon');
    iconContainer.innerHTML = `<span>${iconPointer}</span>`;
    iconContainer.setAttribute('aria-hidden', 'true');
    function addScrollStuff(target) {
        target.classList.add('spv-scrollbox--hasScrollBar');
        target.setAttribute('tabindex', '0');
    }
    function removeScrollStuff(target) {
        target.classList.remove('spv-scrollbox--hasScrollBar');
        target.removeAttribute('tabindex');
    }
    function addScrolledClass() {
        if (element.scrollLeft > 1) {
            element.classList.add('spv-scrollbox--isScrolled');
            element.removeEventListener('scroll', addScrolledClass);
        }
    }
    const resizeObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
            const { target } = entry;
            target.scrollWidth > target.clientWidth ? addScrollStuff(target) : removeScrollStuff(target);
        }
    });
    messageTextContainer.innerText = text;
    message.insertAdjacentElement('afterbegin', iconContainer);
    message.insertAdjacentElement('beforeend', messageTextContainer);
    element.insertAdjacentElement('afterbegin', message);
    resizeObserver.observe(element);
    element.addEventListener('scroll', addScrolledClass);
}
//# sourceMappingURL=makeResponsiveTable.js.map